import {
  GET_LIST_QUANLYCONGVIEC,
  GET_LIST_QUANLYCONGVIEC_SUCCESS,
  GET_LIST_QUANLYCONGVIEC_FAILURE,
} from "actions/QuanLyCongViec/actionTypes";

const initialState = {
  getListQuanLyCongViecLoading: false,
  posts: [],
  objList: {
    List: [],
  },
  totalRow: 0,
};

const getListQuanLyCongViec = (state, action) => ({
  ...state,
  getListQuanLyCongViecLoading: true,
});

const getListQuanLyCongViecSuccess = (state, action) => {
  return {
    ...state,
    getListQuanLyCongViecLoading: false,
    objList: action.payload,
  };
};

const getListQuanLyCongViecFailed = (state, action) => ({
  ...state,
  getListQuanLyCongViecLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_QUANLYCONGVIEC:
      return getListQuanLyCongViec(state, action);
    case GET_LIST_QUANLYCONGVIEC_SUCCESS:
      return getListQuanLyCongViecSuccess(state, action);
    case GET_LIST_QUANLYCONGVIEC_FAILURE:
      return getListQuanLyCongViecFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
